import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: ":jobId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "attendanceSync-report" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
